<template>
  <div class="Type-selector">
    <h4>Aktuell för:</h4>
    <ul class="Type-selector__list">
      <li v-for="type in getTypes()" :key="type.value">{{ type.text }}</li>
    </ul>
    <button
      class="Button Button--secondary Type-selector__button"
      @click="openModal"
    >
      Ändra auktoriseringstyp
    </button>
    <Modal
      :visible="editTypes"
      :title="'Uppdatera områden'"
      @submit="submitEditTypes"
      @cancel="cancelEditTypes"
    >
      <template slot="content">
        <ul>
          <li v-for="type in getTypes(true)" :key="type.value">
            <CheckboxInput
              :checked="isChecked(type.value)"
              @input="typeClicked"
              :text="type.text"
              :value="type.value"
            />
          </li>
        </ul>
        <div class="Form-input__error" v-if="!$v.selectedTypes.required">
          Du måste välja minst ett område.
        </div>
      </template>
      <template slot="buttons">
        <div class="Modal__button">
          <button
            type="button"
            class="Button Button Button--secondary"
            @click="cancelEditTypes"
          >
            Avbryt
          </button>
        </div>
        <div class="Modal__button">
          <button type="submit" class="Button Button Button--primary">
            Uppdatera
          </button>
        </div>
      </template>
    </Modal>
  </div>
</template>

<script>
import { mapState, mapActions } from "vuex";
import CheckboxInput from "@/components/forms/CheckboxInput";
import { authorizationTypes } from "@/utils/constants";
import _ from "lodash";
import Modal from "@/components/Modal";
import { required } from "vuelidate/lib/validators";

export default {
  name: "ApplicationTypeSelector",
  components: {
    Modal,
    CheckboxInput
  },
  data() {
    return {
      editTypes: false,
      selectedTypes: []
    };
  },
  validations: {
    selectedTypes: {
      required
    }
  },
  computed: {
    ...mapState("applicationStore", ["application"])
  },

  methods: {
    ...mapActions("applicationStore", ["updateApplicationTypes"]),
    isChecked(type) {
      return this.application[type];
    },
    getTypes(all) {
      return _(Object.keys(authorizationTypes))
        .filter(type => this.application[authorizationTypes[type].value] || all)
        .map(type => authorizationTypes[type])
        .sortBy(["text"])
        .value();
    },
    openModal() {
      this.selectedTypes = _(Object.keys(authorizationTypes))
        .filter(type => {
          return this.application[authorizationTypes[type].value];
        })
        .map(type => {
          return authorizationTypes[type].value;
        })
        .value();

      this.editTypes = true;
    },
    typeClicked(checked, value) {
      this.selectedTypes = _.remove(this.selectedTypes, function(val) {
        return val !== value;
      });
      if (checked) {
        this.selectedTypes = _.concat(this.selectedTypes, value);
      }
    },
    submitEditTypes() {
      if (this.$v.$invalid) {
        this.$v.$touch();
      } else {
        this.updateApplicationTypes({
          isRecruitment: this.selectedTypes.indexOf("isRecruitment") > -1,
          isAdaptation: this.selectedTypes.indexOf("isAdaptation") > -1,
          isStaffing: this.selectedTypes.indexOf("isStaffing") > -1
        });
        this.cancelEditTypes();
      }
    },
    cancelEditTypes() {
      this.editTypes = false;
      this.$v.$reset();
    }
  }
};
</script>

<style lang="scss" scoped>
.Type-selector {
  padding-bottom: $spacing-L;
  .Form-input {
    @extend %paragraph;
    margin-bottom: $spacing-S/2;
  }

  &__button {
    width: 100%;
  }

  &__list {
    list-style: disc;
    margin-top: $spacing-S;
    margin-bottom: $spacing-S * 2;
    li {
      list-style: disc;
      margin-left: $spacing-L;
    }
  }
}
</style>
